import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import LazyImgixImage from '@components/LazyImgixImage';

import styles from '../../styles.module.scss';

interface SectionProps {
  className?: string;
  imageSrc: string;
  text: string;
  title: string;
}

const Section = ({ className, imageSrc, text, title }: SectionProps) => (
  <div className={clsx('flex flex-col items-center justify-between gap-24 lg:gap-88', className)}>
    <div>
      <h2 className="mb-8 mt-0 font-suisse-works text-headline-xxs text-black sm:text-headline-xs md:text-headline-sm">
        {title}
      </h2>
      <p
        className={clsx(
          'm-0 font-suisse-intl text-body-md font-light text-black sm:text-body-lg',
          styles.section
        )}
      >
        {ReactHtmlParser(text)}
      </p>
    </div>
    <LazyImgixImage
      alt={title}
      className="h-full w-full"
      src={imageSrc}
      sizes="(min-width: 480px) 600px, 400px"
      wrapperClassName="w-full !flex aspect-[3/2] shrink-0 sm:w-[300px] md:w-[480px]"
    />
  </div>
);

export default Section;
